// Formatting shared by the admin console's tabs. A figure we do not hold renders "—", never a fabricated 0.
import { compactNumber, formatRelativeTime } from "@cntrl/ui";

export const dash = "—";

export function figure(n: number | null | undefined): string {
  return n === null || n === undefined ? dash : compactNumber(n);
}

export function exact(n: number | null | undefined): string {
  return n === null || n === undefined ? dash : n.toLocaleString();
}

export function ago(iso: string | null | undefined, never = dash): string {
  return formatRelativeTime(iso) ?? never;
}

export function day(iso: string | null | undefined): string {
  if (!iso) return dash;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? dash : d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

const PLATFORM_LABELS: Record<string, string> = {
  spotify: "Spotify",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  youtube: "YouTube",
  apple_music: "Apple Music",
  amazon: "Amazon",
  deezer: "Deezer",
  soundcloud: "SoundCloud",
};

export function platformLabel(key: string | null | undefined): string {
  if (!key) return dash;
  return PLATFORM_LABELS[key] ?? key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Case-insensitive match of a search box against any of the given strings. */
export function matches(query: string, ...fields: (string | null | undefined)[]): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => f?.toLowerCase().includes(q));
}
